(function ($, window) {

  // On document ready
  $(function () {
  });

  let customMaps = $('.hfg-map-container');

  if (!customMaps.length) {
    return;
  }

  
  let mapInitFunctions = [];

  customMaps.each((i, customMap) => {
    let mapEl = $(customMap);
    let mapID = mapEl.data('block-id');
    if (typeof window.mapDataACFgmap == 'object' && typeof window.mapDataACFgmap[mapID] == 'object') {
      makeNewACFgmap(mapEl, mapID);
    }
  });

  function makeNewACFgmap(customMap, mapID) {
    
    let mapData = window.mapDataACFgmap[mapID];

    let mapNav = $('<ul/>');
    let mapLocationsList = customMap.find('.hfg-map-locations');

    if (mapData.categories.length) {
      mapData.categories.forEach((category, i) => {
        let catLink = $('<a/>').text(category.category);
        let catLi = $('<li/>');
        catLi.append(catLink);
  
        catLink.click(function (e) {
          e.preventDefault();
          let thisLink = $(this);
          thisLink.toggleClass('expanded');
          if (thisLink.hasClass('expanded')) {
            mapNav.find('> li > a').not(thisLink).removeClass('expanded');
          }
          
          // console.log(i * thisLink[0].getBoundingClientRect().height);

          gsap.to(mapLocationsList[0], {
            duration: 0.3, 
            // scrollTo: parseInt(mapLocationsList.css('padding-top')) + thisLink.position().top,
            scrollTo: i * thisLink[0].getBoundingClientRect().height,
            ease: "power3.out"
          });

          // Alternatively, without GSAP, mapLocationsList.scrollTop(i * thisLink[0].getBoundingClientRect().height);
        });
  
        let locations = $('<ul/>');
        if (typeof category.locations == 'object') {
  
          category.locations.forEach((location) => {
  
            // Place link
    
            let locationLink = $('<a/>').text(location.name);
            locationLink.click(function () {
              // Not doing this here yet because marker hasn't been generated
            });
            locations.append($('<li/>').append(locationLink));
            location.link = locationLink;
          });
          catLi.append(locations);
          mapNav.append(catLi);
        }
        
      });
      
      mapLocationsList.append(mapNav);
    }
    else {
      mapLocationsList.remove();
    }


    mapInitFunctions.push(() => {

      let map = new google.maps.Map(customMap.find('.hfg-gmap')[0], {
        center: { lat: mapData.estateLatLng[0], lng: mapData.estateLatLng[1] },
        zoom: 11,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        styles: customMapStyle
      });
    
      let estateMarkerIcon;
      if (mapData.estateMarkerOrientation == 'alternative') {
        estateMarkerIcon = {
          url: FJ_DATA.stylesheet_uri + '/img/estate-marker-alt.png',
          anchor: new google.maps.Point(180, 31),
          scaledSize: new google.maps.Size(185, 62)
        };
      }
      else {
        estateMarkerIcon = {
          url: FJ_DATA.stylesheet_uri + '/img/estate-marker.png',
          anchor: new google.maps.Point(100, 45),
          scaledSize: new google.maps.Size(200, 91)
        };
      }

      let mainMarker = new google.maps.Marker({
        map: map,
        position: { lat: mapData.estateLatLng[0], lng: mapData.estateLatLng[1] },
        clickable: false,
        icon: estateMarkerIcon,
        zIndex: 1000
      });

      map.panBy(0,-50);

      if (!mapData.categories.length) {  
        return;
      }

      if (customMaps.width() < 1100 && customMaps.width() > 767) {
        map.panBy(180,0);
      }

      var bounds = new google.maps.LatLngBounds();
      var infoWindow = new google.maps.InfoWindow({
        maxWidth: 290
      });
      let locations = [];

      mapData.categories.forEach((category, i) => {
        if (typeof category.locations == 'object') {
          category.locations.forEach((location) => {
  
            bounds.extend({ lat: location.latLng[0], lng: location.latLng[1] });
  
            location.isTransport = category.category == 'Transport';
            locations.push(location);
  
          });
        }
      });

      // map.fitBounds(bounds);

      locations.sort((a, b) => a.latLng[1] - b.latLng[1]);

      locations.forEach((location, i) => {
        setTimeout(function () {
          marker = new google.maps.Marker({
            map: map,
            animation: google.maps.Animation.DROP,
            position: { lat: location.latLng[0], lng: location.latLng[1] },
            icon: location.isTransport ? 
              {
                url: FJ_DATA.stylesheet_uri + '/img/tfl.png',
                scaledSize: new google.maps.Size(34, 34),
                anchor: new google.maps.Point(17, 17)
              } : 
              FJ_DATA.stylesheet_uri + '/img/poi.png'
          });

          location.link.click(goToMarker(location, marker));

          google.maps.event.addListener(marker, 'click', goToMarker(location, marker));
        }, i * 40);
      });

      function goToMarker(location, marker) {

        return function () {
          
          infoWindow.setContent(`<h3>${location.name}</h3>
          ${location.popup_text ? `<div class="intro">${location.popup_text}</div>` : ''}
          ${location.mapLink ? `<a class="ext-link" href="${location.mapLink}" target="_blank">Visit Website</a>` : ''}
          ${location.address ? `<div class="address">${location.address}</div>` : ''}
          ${location.walk_time ? `<div class="walk-time">${location.walk_time} minutes' walk</div>` : ''}`);

          infoWindow.open(map, marker);
          map.panTo({ lat: location.latLng[0], lng: location.latLng[1] });
          if (customMaps.width() < 1100 && customMaps.width() > 767) {
            map.panBy(180,0);
          }

          // map.setZoom(12);
        }
      }

      $(window).on('sectionTabNav', (e, section) => {

        setTimeout(() => {
          if (section.find('.hfg-gmap').length) {
            google.maps.event.trigger(map, 'resize');
            map.fitBounds(bounds);
          }
        }, 0);
      });
    });
  }
 
  window.initMap = () => {
    mapInitFunctions.forEach(fn => {fn();})
  };




  let customMapStyle = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ededed"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#a2a2a2"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },

    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.business",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },

    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },

    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },

    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },

    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ccd1d4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];

})(jQuery, window);
